import { Toast, ToastBody } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { Bell, Disc } from "react-feather";
import { useState } from "react";
import { CommonToastProp } from "../../../../Type/CommonComponant";

export const CommonToast = ({ item }: CommonToastProp) => {
  const [open, setOpen] = useState(true);

  return (
    <Toast isOpen={open}>
      <div className="toast-header">
        {item.bell ? <Bell className={`toast-icons toast-${item.iconColor}`} /> : <Disc className={`toast-icons toast-${item.iconColor}`} />}
        <strong className="me-auto">{item.title}</strong>
        <small className={item.bell ? "" : "text-muted d-sm-block d-none"}>{item.time}</small>
        <Btn className="btn-close p-0" onClick={() => setOpen(false)}></Btn>
      </div>
      <ToastBody className="toast-dark">{item.bodyText}</ToastBody>
    </Toast>
  );
};
